module.exports = __webpack_public_path__ + "img/modal-arrow.383c3a56.svg";